import hdrm from '../../hdrm';
import elementMatchesSelector from '../verifiers/element-matches-selector';
import events from '../constants/events';

const interruptDeleteElement = (eventData, action) => {
  const { elementId } = action.payload;
  const element = hdrm.accessors.getStaticElement(elementId);

  if (eventData.action !== events.DELETE_ELEMENT) {
    return null;
  }

  return elementMatchesSelector(element, eventData.options.selector) ? {} : null;
};

export default interruptDeleteElement;
